import React, { FC, useEffect, useState } from 'react';
import { Modal, Tabs } from 'antd';
import { RootState } from '../../../../rootReducer';
import { AppDispatch } from '../../../../store';
import { connect } from 'react-redux';
import { setGoFromFindingToImage, setShowCreateAnnotationModal } from './AnnotationForm.slice';
import { annotationCreationCanceled } from '../../Canvas/canvas.slice';
import AnnotationTab from './Annotation/AnnotationTab';
import CommentsTab from './Comments/CommentsTab';
import styles from './AnnotationForm.module.scss';
import { UseHaveAnyPermissions } from '../../../../Auth/UseHaveAnyPermissions';
import { Permissions } from '../../../../shared/models/permissions.enum';
import { ANNOTATION_TAB_KEY, COMMENTS_TAB_KEY } from './Helpers';
import { getAnnotationCommentsCount } from './Comments/AnnotationComments.slice';

const { TabPane } = Tabs;

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const AnnotationFormModal: FC<Props> = ({
  showModal,
  annotationForEdit,
  canAnnotate,
  commentsCount,
  onHideModal,
  onCreateAnnotationCanceled,
  onGoToImage,
  onGetCommentsCount
}) => {
  const [selectedTabKey, setSelectedTabKey] = useState<string>(ANNOTATION_TAB_KEY);
  //TODO: Should we move this??
  const canEditAnnotation = UseHaveAnyPermissions([Permissions.AnnotationManager_CreateAnnotation, Permissions.AnnotationManager_UpdateAnnotation]);
  const canSeeComments = UseHaveAnyPermissions([
    Permissions.AnnotationManager_AddComments,
    Permissions.AnnotationManager_DeleteComments,
    Permissions.AnnotationManager_EditComments
  ]);

  useEffect(() => {
    onGetCommentsCount();
  }, [onGetCommentsCount]);

  const cancelAnnotationCreation = () => {
    onGoToImage();
    onHideModal(false);
    onCreateAnnotationCanceled();
  };

  return (
    <Modal wrapClassName='annotation-modal' className='modal-container' visible={showModal} onCancel={() => cancelAnnotationCreation()} footer={null}>
      <Tabs onChange={setSelectedTabKey}>
        {canEditAnnotation && canAnnotate && (
          <TabPane tab='Annotation' key={ANNOTATION_TAB_KEY} className={styles.tabPane}>
            <AnnotationTab selectedTabKey={selectedTabKey} cancelAnnotationCreation={cancelAnnotationCreation} />
          </TabPane>
        )}
        {canSeeComments && (
          <TabPane tab={`Comments (${commentsCount})`} key={COMMENTS_TAB_KEY} disabled={!annotationForEdit} className={styles.tabPane}>
            <CommentsTab />
          </TabPane>
        )}
      </Tabs>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  showModal: state.annotationForm.showCreateAnnotationModal,
  annotationForEdit: state.annotationForm.selectedAnnotationForEdit,
  canAnnotate: state.annotation.havePermissionToAnnotate,
  commentsCount: state.annotationComments.commentsCount
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onHideModal: (show: boolean) => dispatch(setShowCreateAnnotationModal(show)),
  onCreateAnnotationCanceled: () => dispatch(annotationCreationCanceled(true)),
  onGoToImage: () => dispatch(setGoFromFindingToImage(true)),
  onGetCommentsCount: () => dispatch(getAnnotationCommentsCount(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(AnnotationFormModal);
